<template>
    <div class="contact-box">
        <div class="banner"></div>
        <div class="contact">
            <p>Grand Channel Inc.</p>
            <p>operator@grandchannel.us</p>
            <p>909-443-5876</p>
            <p>13780 Central Ave</p>
            <p>Chino, CA 91710</p>
            <p>USA</p>
        </div>
    </div>
</template>
<script>
    export default {
      name: 'contact-box',
      data () {
        return {

        }
      },
      components:{

      },
      methods:{

      },
      computed:{

      },
      mounted(){

      },
      watch:{
        // 如果 `某个属性` 发生改变，这个属性对应的函数就会运行
      }
    }
</script>
<style scoped lang="scss">
    .contact-box {
      width: 100%;
      .banner {
        width: 100%;
        height:383px;
        background:url('../../assets/images/contact/img6.png') no-repeat center top;
        background-size: 100% auto;
      }
      .contact {
        font-size: 16px;
        text-align: center;
        padding:100px;
        p {
            height:30px;
            line-height: 30px;
        }
      }
    }
</style>


// WEBPACK FOOTER //
// src/views/contact/contact.vue